var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mt-5",attrs:{"lg":"4","offset-lg":"4"}},[_c('forgot-password-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }